


















































import {
  computed, defineComponent, onMounted, ref,
} from '@nuxtjs/composition-api';
import { SfButton, SfIcon } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { usePaymentCard } from '~/composables';
import { useCheckoutStore } from '~/stores/checkout';
import JetUiButton from '../../atoms/JetUiButton/JetUiButton.vue';
import CreditCardListDesktop from './CreditCardList/CreditCardListDesktop.vue';
import CreditCardListMobile from './CreditCardList/CreditCardListMobile.vue';
import InsertNewCard from './InsertNewCard.vue';
import InstallmentsForm from './InstallmentsForm.vue';
import SelectedCardDetails from './SelectedCardDetails.vue';

export default defineComponent({
  name: 'PaymentCardContent',
  components: {
    SvgImage,
    InstallmentsForm,
    InsertNewCard,
    JetUiButton,
    SfButton,
    SfIcon,
    CreditCardListDesktop,
    SelectedCardDetails,
    CreditCardListMobile,
  },
  setup() {
    const selectedInstallment = ref(null);
    const isAddCardOpened = ref(false);
    const currentIndex = ref(-1);
    const {
      paymentCards, loading, decrypt, createPaymentCard, deletePaymentCard, selectCard, selectInstallment, fetchPaymentCards, selectedPaymentCard,
    } = usePaymentCard();
    const checkoutStore = useCheckoutStore();

    const handleCardClick = (paymentCard, index) => {
      currentIndex.value = index;
      selectCard(paymentCard);
    };

    const resetSelection = () => {
      selectCard(null);
      currentIndex.value = -1;
    };

    const backToPaymentSelection = () => {
      checkoutStore.setSelectedPaymentMethod(null);
    };

    const toggleAddCard = () => {
      isAddCardOpened.value = !isAddCardOpened.value;
    };

    const setInstallment = (option) => {
      selectedInstallment.value = option;
      selectInstallment(option);
    };

    const addCreditCard = (form: any) => {
      selectCard(form);
      
      toggleAddCard();
    };

    const isMobile = computed(() => typeof window !== 'undefined' && window.innerWidth <= 768);

    function censoredText(text: string) {
      return text.replace(/\S/g, (char, index) => (index < 14 ? '\u25CF' : char));
    }

    onMounted(async () => {
      loading.value = true;
      // await fetchPaymentCards();
    });

    return {
      loading,
      paymentCards,
      isAddCardOpened,
      toggleAddCard,
      censoredText,
      addCreditCard,
      selectCard,
      deletePaymentCard,
      decrypt,
      handleCardClick,
      setInstallment,
      selectedInstallment,
      backToPaymentSelection,
      currentIndex,
      resetSelection,
      selectedPaymentCard,
      isMobile,

    };
  },
});
